import styled from '@emotion/styled';

export default styled('div')`
  border-radius: 50px;
  position: relative;
`;
